export default data => data.reduce((a, b) => a + b) / data.length
